import { formatNumber } from '#core/lib/formatters/number-decimals.ts';

interface NumberCellProps {
  value: number;
  decimalScale?: number;
  /** Whether to render a thousand separator. Defaults to `true`. */
  thousandSeparator?: boolean;
}

/**
 * Renders a number value with optional thousands separator and consistent decimal places.
 * Uses fixedDecimalScale to ensure all rows align (e.g. 0 displays as "0.00").
 *
 * The thousand separator is on by default; pass `thousandSeparator={false}` for
 * columns where it would be misleading (e.g. years — "2025" not "2,025").
 */
export function NumberCell({ value, decimalScale, thousandSeparator = true }: NumberCellProps) {
  return <>{formatNumber(value, { scale: decimalScale, useThousandSeparator: thousandSeparator })}</>;
}
